export const routePaths = {
	home: '/student/',
	login: '/student/login',
	loginByClever: '/student/login/by-clever',
	loginByClasslink: '/student/login/by-class-link',
	studentAssignments: '/student/student-assignments',
};
